__turbopack_context__.v({
  "bounceDot": "LoadingSpinner-module__DKcTUq__bounceDot",
  "dot": "LoadingSpinner-module__DKcTUq__dot",
  "dotsContainer": "LoadingSpinner-module__DKcTUq__dotsContainer",
  "loadingText": "LoadingSpinner-module__DKcTUq__loadingText",
  "spinnerWrapper": "LoadingSpinner-module__DKcTUq__spinnerWrapper",
});
